<script>
import toggle from '@utils/design/toggle-info'

export default {
  methods: {
    handleDragstart(e) {
      let data = {}

      if (e.target.name === 'fish') {
        data = {
          component: 'metric',
          meta: {
            color: e.target.style.color,
            coreEntity: 'cycle',
          },
        }
      } else {
        data = {
          component: 'color',
          meta: {
            color: e.target.style.backgroundColor,
          },
        }
      }
      e.dataTransfer.setData('text', JSON.stringify(data))
      toggle(false)
    },
  },
}
</script>

<template>
  <b-tabs pills class="pt-2" align="left">
    <b-tab title="SUMMARY" active>
      <div class="color-swatch ml-2 mt-2">
        <div
          v-for="n in 12"
          :key="n"
          class="color-swatch__color"
          :style="{ backgroundColor: 'hsl(' + (n - 1) * 30 + ', 90%, 73%)' }"
          draggable="true"
          name="color"
          @dragstart="handleDragstart"
        ></div>
      </div>
    </b-tab>

    <b-tab title="CYCLE">
      <button
        type="button"
        class="insights-list list-group-item list-group-item-action text-uppercase text-success"
        draggable="true"
        name="fish"
        @dragstart="handleDragstart"
      >
        Metric
      </button>
      <button
        type="button"
        class="insights-list list-group-item list-group-item-action text-uppercase text-info"
        draggable="true"
        @dragstart="handleDragstart"
      >
        Active
      </button>
      <button
        type="button"
        class="insights-list list-group-item list-group-item-action text-uppercase  text-success"
        draggable="true"
        @dragstart="handleDragstart"
      >
        Complete
      </button>
      <button
        type="button"
        class="insights-list list-group-item list-group-item-action text-uppercase text-info"
        draggable="true"
        @dragstart="handleDragstart"
      >
        Actual Vs Forecast
      </button>
    </b-tab>
    <b-tab title="ACTIVITY"> </b-tab>
    <b-tab title="CONDITION"> </b-tab>
    <b-tab title="ACTIONS"> </b-tab>
    <b-tab v-if="true" title="OTHER"> <BaseInfoSideFiltersDate /></b-tab>
  </b-tabs>
</template>

<style>
.color-swatch__color {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin: 5px;
  cursor: move;
}
.nav-pills {
  margin-bottom: 12px !important;
}
.nav-pills .nav-item {
  min-width: 50%;
}
.nav-pills .nav-link {
  margin-left: 12px;
  border: 1px solid #000000;
  margin-top: 6px;
}

.b-card-body:hover {
  z-index: 1;
  color: #e4e7ea;
  text-decoration: none;
  background-color: #2f353a;
}
::selection {
  background: #000; /* WebKit/Blink Browsers */
}
::-moz-selection {
  background: #000; /* Gecko Browsers */
}
.nav-pills {
  font-size: 1.09375rem !important;
  text-transform: uppercase !important;
  font-weight: 500 !important;
}
.insights-list:first-child {
  border-top: none;
}
</style>
